<template>
	<div id="sign-in-xp">
		<img class="bg" :src="httpImg+`/invitation-xp/invite-bg3.png`">
		<div class="logo-box">
			{{ $t('sign.regist') }}
			<img class="logo" :src="httpImg+`/invitation-xp/logo-xp3.png`">
		</div>

		<div v-if="tagShow" class="switch-box">
			<span :class="isPhone ? 'active' : ''" @click="switchType(true)">
				{{ $t('sign.mobile_regist') }}
				<img class="after" :src="httpImg+`/invitation-xp/invite-13.png`">
			</span>
			<span :class="!isPhone ? 'active' : ''" @click="switchType(false)">
				{{ $t('sign.email_regist') }}
				<img class="after" :src="httpImg+`/invitation-xp/invite-13.png`">
			</span>
		</div>
		<div class="form-box">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">

				<el-form-item prop="phone">
					<div class="h3">{{isPhone ? $t('sign.mobile_xp'):$t('sign.email_xp')}}</div>
					<div class="input-box phone">
						<!-- <i :class="isPhone ? 'el-icon-mobile-phone' : 'el-icon-message'" class="left" /> -->
						<code-select v-if="isPhone" :area-list="areaList" class="left code" @code-change="codeChange" />
						<!-- <img class="after" :src="httpImg+`/invitation-xp/invite-12.png`"> -->
						<div v-if="isPhone" class="line"></div>
						<el-input v-model="ruleForm.phone" ref="phone" type="text" size="medium"
							class="value-input username-input left" :class="isPhone ? '' : 'mail-input'"
							:placeholder="isPhone ? $t('sign.input_phone') : $t('sign.input_email')" autocomplete="on"
							clearable />
					</div>
				</el-form-item>

				<el-form-item prop="phone">
					<div class="h3">{{$t('sign.code_xp')}}</div>
					<div class="input-box phone">
						<el-input v-model="ruleForm.code" ref="code" type="number" max="6" size="medium"
							class="value-input code-input left" :placeholder="$t('sign.input_code')" clearable />
						<div @click="sendCode" :class="codeNum ? '':'on'" class="codeText">
							<span>{{codeNum ? (codeNum+'s'):codeNum === 0  ? $t('sign.resend'):$t('sign.get_code_xp')}}</span>
							{{codeNum ? $t('sign.get_code2_xp'):''}}
						</div>
					</div>
				</el-form-item>

				<el-form-item prop="password">
					<div class="h3">{{$t('sign.set_pwd')}}</div>
					<div class="input-box password">
						<!-- prefix-icon="el-icon-lock" -->
						<el-input v-model="ruleForm.password" name="password" :type="eyeOpen ? 'text' : 'password'"
							class="value-input password-input" size="medium" :placeholder="$t('sign.set_password')"
							autocomplete="on" clearable />
						<span class="eye" @click="eyeOpen = !eyeOpen">
							<img v-if="!eyeOpen" src="@/assets/fixed-invitation/eye.png" alt="">
							<img v-else src="@/assets/fixed-invitation/eye-o.png" alt="">
						</span>
					</div>
					<!-- <span class="pass-tip">({{ $t('sign.password_rule') }})</span> -->
				</el-form-item>

				<el-form-item prop="inviteCode">
					<div class="input-box invite-code">
						<div class="code">{{ $t('sign.invite_code') }}：{{ruleForm.inviteCode}}</div>
					</div>
				</el-form-item>
			</el-form>
		</div>
		<div class="sign-in-btn" :class="ruleForm.password && ruleForm.code && ruleForm.phone ? 'active' : ''"
			@click="goInputCode">{{ $t('sign.regist') }}</div>
		<!-- 协议 -->
		<div class="protocal-box">
			<span class="protocal">
				{{ $t('sign.regist_text') }}
				<a :href="`https://xp.com/protocol/index.html?language=${language}`" target="_blank"
					rel="noopener noreferrer">
					{{ $t('sign.agreement') }}
				</a>
			</span>
			<!-- https://sanrenxing.pro/protocol/ -->
		</div>

		<!-- <div><span class="login-btn" @click="goDown">{{ $t('sign.already_regist') }}</span></div> -->

		<div class="down-logo">
			<div class="left">
				<div class="logo">
					<img :src="httpImg+`/invitation-xp/logo-xp.png`">
				</div>
				<div class="text">
					<p>XP APP</p>
					<span>{{ $t('sign.trade') }}</span>
				</div>
			</div>
			<div class="down" @click="goDown">{{ $t('sign.down') }}</div>
		</div>


		<div class="alert" v-show="alertShow">
			<span>{{message}}</span>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';
	import CodeSelect from '@/components/CodeSelect/new.vue'
	import {
		isNum,
		validPassword,
		validEmail
	} from '@/utils/validate'
	const Base64 = require('js-base64').Base64
	export default {
		name: 'SignIn',
		components: {
			CodeSelect
		},
		data() {
			const self = this
			const validatePhone = (rule, value, callback) => {
				// debugger
				if (self.isPhone && !isNum(value)) {
					callback(new Error(self.$t('sign.phone_warn')))
				} else if (!self.isPhone && !validEmail(value)) {
					callback(new Error(self.$t('sign.email_warn')))
				} else {}
			}
			const validatePass = (rule, value, callback) => {
				if (!validPassword(value)) {
					self.active = false
					callback(new Error(self.$t('sign.password_warn')))
				} else {
					if (self.checked) {
						self.active = true
					} else {
						self.active = false
					}
					callback()
				}
			}
			const checkCode = (rule, value, callback) => {
				callback()
			}
			return {
				isPhone: true,
				areaList: [],
				area: '852',
				drawer: false,
				eyeOpen: false,
				alertShow: false,
				message: '',
				ruleForm: {
					phone: '',
					password: '',
					inviteCode: '',
				},
				rules: {
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					password: [{
						required: true,
						validator: validatePass,
						trigger: 'change'
					}],
					code: [{
						required: true,
						validator: checkCode,
						trigger: 'change'
					}]
				},
				inviteCode: 'AFDIXE',
				checked: true,
				active: false,
				language: '',
				tagShow: true,
				codeNum: '',
				aboutsList: '',
			}
		},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				httpImg: state => state.httpImg
			}),
		},
		mounted() {
			if (this.$i18n.locale === 'zh') {
				this.language = 'CHINESE'
			} else if (this.$i18n.locale === 'zh-h') {
				this.language = 'CHINESETRAD'
			} else {
				this.language = 'ENGLISH'
			}

			let data = this.$route.query.d
			if (data) {
				this.infoCode = Base64.decode(data).split('_')[1];
			}
			this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
			this.getAreaList()


		},
		methods: {
			sendCode() {
				if (!this.ruleForm.phone) {
					this.showAlert(this.$t('sign.input_phone'))
					return
				}

				const params = this.isPhone ? {
					mobile: (this.area + '') + parseInt(this.ruleForm.phone + ''),
					useFor: 'register',
					scope: 'XP_DATA',
					'language': this.language
				} : {
					email: this.ruleForm.phone,
					useFor: 'register',
					scope: 'XP_DATA',
					'language': this.language
				};
				this.codeNum = 60;
				this.$MyAxios.post(`/api/accounts/verificationCode`,
					params,
					true,
					response => {
						if (response.code === 1) {
							this.countDownFunc = setInterval(() => {
								if (this.codeNum > 1) {
									this.codeNum--
								} else {
									this.codeNum = 0
									clearInterval(this.countDownFunc)
									this.countDownFunc = null
								}
							}, 1000)
						}
					}, error => {
						this.alertShow = true
						this.message = error
						setTimeout(() => {
							this.alertShow = false
						}, 2000);
						this.countDownFunc = setInterval(() => {
							if (this.codeNum > 1) {
								this.codeNum--
							} else {
								this.codeNum = 0
								clearInterval(this.countDownFunc)
								this.countDownFunc = null
							}
						}, 1000)
					})


			},
			getAreaList() {
				this.$MyAxios.get(`/api/accounts/locations`, {},
					response => {
						if (response.code === 1) {
							let data = response.data
							this.areaList = data
						}
					}, error => {})
				this.$MyAxios.get(`/api/accounts/abouts?scope=xp`, {},
					response => {
						if (response.code === 1) {
							let data = response.data
							this.aboutsList = data
						}
					}, error => {})
			},
			handleClose(done) {
				done()
			},
			codeChange(code) {
				this.area = code
			},
			switchType(flag) {
				// 
				this.isPhone = flag
				this.ruleForm.phone = '';
				this.$refs['ruleForm'].resetFields()
				this.ruleForm.inviteCode = this.$route.query.inviteCode ? this.$route.query.inviteCode : this.infoCode
			},
			goInputCode() {

				let params = {}
				if (this.isPhone) {
					let mobile = parseInt(this.ruleForm.phone + '')
					params.mobile = (this.area + '') + mobile
				} else {
					params.email = this.ruleForm.phone
				}


				this.$MyAxios.get(`/api/accounts/${this.isPhone ? 'mobile' : 'email'}/isAvailable`, {
						params: params
					},
					response => {
						if (response.code === 1) {
							if (response.data) {
								// console.log('去注册')
								this.register()
							} else {
								this.showAlert(this.$t('sign.user_exists'))
							}
						}
					}, error => {

					})
			},
			register() {
				this.showAlert(this.$t('sign.currently_regist') + '...')
				let params = {
					password: this.ruleForm.password,
					code: this.ruleForm.code,
					inviteCode: this.ruleForm.inviteCode,
					scope: 'JGZ',
					roles: ''
				}
				if (this.isPhone) {
					if (this.area == 86) {
						this.showAlert(this.$t('sign.no_cn'))
						return
					}
					let mobile = parseInt(this.ruleForm.phone + '')
					params['mobile'] = (this.area + '') + mobile
				} else {
					params['email'] = this.ruleForm.phone
				}
				this.$MyAxios.post(`/register`,
					params,
					false,
					response => {
						if (response.code === 1) {
							//跳转成功页
							this.$router.push({
								name: 'success-xp',
							})
						}
					}, error => {
						this.showAlert(error)
					})
			},
			checkChange() {
				if (this.checked) {
					this.$refs.ruleForm.validate(valid => {
						if (valid) {
							this.active = true
						}
					})
				} else {
					this.active = false
				}
			},
			goDown() {
				//跳转下载页
				this.$router.push({
					name: 'Download-xp',
				})
			},
			showAlert(message) {
				this.message = message;
				this.alertShow = true;
				setTimeout(() => {
					this.alertShow = false;
				}, 2000);
			},
		}
	}
</script>

<style lang='less'>
	#sign-in-xp {
		min-height: 100vh;
		width: 100%;
		padding: 64px 60px 240px 60px;
		background-color: #ffffff;
		position: relative;
		z-index: 2;

		.bg {
			width: 100%;
			position: absolute;
			left: 0;
			top: 0;
			z-index: -1;
		}

		.logo-box {
			margin-bottom: 64px;
			font-size: 54px;
			color: #1E2329;
			font-weight: bold;
			display: flex;
			align-items: center;
			justify-content: center;

			.logo {
				width: 188px;
				height: 44px;
				margin-left: 16px;
			}
		}

		.switch-box {
			height: 126px;
			position: relative;

			span {
				position: absolute;
				display: flex;
				justify-content: center;
				line-height: 96px;
				height: 126px;
				width: 270px;
				color: #9598A6;
				background: #F5F5F5;
				top: 0;
				right: 0;
				border-radius: 0 32px 0 0;
				font-size: 32px;

				.after {
					display: none;
				}

				&.active {
					top: 0;
					width: 320px;
					background: #ffffff;
					color: #1E2329;
					z-index: 4;
					border-radius: 32px 32px 0 0;
					padding-right: 40px;

					.after {
						display: block;
						position: absolute;
						top: 0;
						left: -80px;
						width: 80px;
						height: 110px;
						transform: rotateY(180deg);
					}
				}
			}

			span:nth-child(1) {
				left: 0;
				right: auto;
				border-radius: 32px 0 0 0;


				&.active {
					/* border-radius: 32px 32px 0 0; */
					border-radius: 32px 32px -32px 0;
					padding: 0 0 0 40px;

					.after {
						right: -80px;
						left: auto;
						transform: rotateY(0);
					}
				}
			}
		}

		.form-box {
			background: #ffffff;
			margin: -30px 0 0 0;
			border-radius: 32px 32px 0 0;
			padding: 32px 32px 0 32px;
			overflow: hidden;
			position: relative;
			z-index: 5;

			.h3 {
				font-size: 28px;
				color: #A1A6AE;
				margin: 16px 0;
			}

			.el-form-item {
				text-align: left;

				.el-form-item__error {
					font-size: 20px;
					margin-top: 4px;
				}
			}

			.input-box {
				height: 100px;
				border-radius: 16px;
				height: 88px;
				border: 1px solid #EAECEF;
				overflow: hidden;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.code-select {
					height: 100%;
				}

				.left.code .show {
					width: 160px;
					display: flex;
					align-items: center;
					justify-content: center;
					line-height: 88px;
					font-size: 28px;
				}

				.after {
					width: 16px;
					height: 10px;
					display: inline-block;
					margin-left: 16px;
				}

				.el-icon-mobile-phone,
				.el-icon-message {
					height: 100%;
					line-height: 100%;
					width: 40px;
					text-align: center;
					color: #33333a;
					margin-right: 10px;
					padding-left: 15px;
					font-size: 36px;
					vertical-align: middle;
					font-weight: bold;
				}

				&.phone {
					position: relative;

					.line {
						width: 2px;
						height: 32px;
						/* position: absolute;
						left: 162px;
						top: 30px; */
						background: #EBECF0;
					}
				}

				&.password {
					position: relative;

					.el-input__suffix {
						right: 80px;
					}

					.el-input__icon {
						color: #33333a;
						font-weight: bold;

						&:before {
							border-radius: 50%;
							background: #ffffff;
						}

						&.el-input__clear {
							color: #CCCED9;
						}
					}

					.eye {
						display: inline-block;
						position: absolute;
						height: 34px;
						width: 34px;
						top: 28px;
						right: 20px;

						img {
							height: 34px;
							width: 34px;
						}
					}
				}
			}

			.pass-tip {
				font-size: 24px;
				line-height: 34px;
				color: #CCCED9;
				padding-left: 30px;
			}

			.el-input {
				height: 100%;
				font-size: 40px;

				.el-input__inner {
					display: block;
					height: 100%;
					padding: 0 30px;
					border: none;
					font-size: 28px;

					&::-webkit-input-placeholder {
						font-size: 28px;
					}
				}

				.el-input__prefix {
					width: 32px;

					.el-input__icon:before {
						line-height: 88px;
						width: 32px;

					}
				}

				.el-input__suffix {
					right: 30px;
					width: 32px;

					.el-input__icon:before {
						line-height: 88px;
						width: 32px;
						font-size: 32px;
					}
				}

				&.is-disabled .el-input__inner {
					color: #9598A6;
					background-color: #F8F9FB;
				}
			}

			.code-input {
				width: 60%;
			}

			.codeText {
				width: 40%;
				text-align: center;
				font-size: 28px;
				line-height: 88px;
				color: #A1A6AE;
				pointer-events: none;

				span {
					color: #00C2E0;
				}

				&.on {
					pointer-events: auto;
				}
			}

			.code-select .area-list-box.show .el-input .el-input__inner {
				font-size: 28px;
			}

			.username-input {
				width: 380px;
				height: 100%;
				overflow: hidden;
				line-height: 88px;
				margin-top: -1px;

				&.mail-input {
					width: 100%;
					padding-left: 32px;
				}

				.el-input__inner {
					padding: 0 32px 0 0;
					height: 100%;
					line-height: 88px;
					font-size: 28px;
				}
			}

			.password-input {
				margin-top: -1px;
			}

			.invite-code {
				background: #F5F5F5;
				border: 0px;
				width: 400px;
				height: 56px;
				margin: 32px auto 0 auto;
				border-radius: 16px;
				line-height: 56px;

				.code {
					text-align: center;
					display: block;
					color: #848E9C;
					font-size: 28px;
					vertical-align: middle;
					width: 100%;
				}
			}
		}

		.protocal-box {
			text-align: center;
			margin-bottom: 30px;
		}

		.protocal {
			font-size: 24px;
			line-height: 32px;
			color: #A1A6AE;
			vertical-align: middle;

			a {
				font-size: 24px;
				color: #1E2329;

				&.en {
					font-style: italic;
				}
			}
		}

		.sign-in-btn {
			width: 620px;
			height: 88px;
			border-radius: 8px;
			color: #A1A6AE;
			background: #EAECEF;
			text-align: center;
			font-size: 28px;
			line-height: 88px;
			margin: 32px 0 24px 0;
			pointer-events: none;

			&.active {
				color: #ffffff;
				background: #1E2329;
				pointer-events: auto;
			}
		}

		.login-btn {
			color: #FFA41F;
			font-size: 34px;
			text-decoration: underline;
		}

		.down-logo {
			height: 120px;
			position: fixed;
			z-index: 8;
			bottom: 40px;
			left: 40px;
			right: 40px;
			padding: 20px 24px;
			background: #ffffff;
			border-radius: 16px;
			box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.logo {
					height: 80px;
					width: 80px;
					display: flex;
					align-items: center;
					justify-content: center;
					border-radius: 16px;
					background: #1E2329;
					margin-right: 24px;
				}

				img {
					width: 56px;
					height: 36px;
				}

				.text {
					text-align: left;

					p {
						font-size: 32px;
						font-weight: bold;
						color: #1E2329;
						line-height: 44px;
					}

					span {
						display: block;
						color: #A1A6AE;
						font-size: 24px;
						line-height: 18px;
						margin-top: 4px;
					}
				}
			}


			.down {
				width: 144px;
				height: 64px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #ffffff;
				font-size: 24px;
				background: #1E2329;
				border-radius: 16px;
			}
		}


	}

	.alert {
		position: fixed;
		z-index: 9;
		top: 40%;
		left: 50%;
		height: 76px;
		width: auto;
		padding: 0 30px;
		transform: translateX(-50%);
		border-radius: 16px;
		background: rgba(0, 0, 0, .9);
		color: #ffffff;
		line-height: 76px;
		font-size: 26px;
	}

	/* .down {} */
</style>